import { CircularProgress, Stack, Typography } from '@mui/material';
import React from 'react';

const GeneralLoader = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <Stack direction='row' alignItems='center' spacing={2} m={2}>
          <CircularProgress size={30} />
          <Typography>Loading ...</Typography>
        </Stack>
      )}
    </>
  );
};

export default GeneralLoader;
